import APIEntry from "@/api/APIEntry.js";
import { CONFIG } from "@/datas/configs.js";
import axios from "axios";
import store from "../store";
import { tokenRefreshManager } from "./tokenRefreshManager.js";

/**
 * Global mapping interfaces
 */
export default Object.freeze({
  /**
   * api entry 매칭 시키기
   */
  entry: function() {
    if (!arguments.length) {
      return null;
    }
    let args = [];
    Array.prototype.push.apply(args, arguments);

    // let $store = args.shift();

    let match = store.state.entries[args[0]];

    if (typeof match === undefined) {
      return null;
    }
    args.shift();

    // shopNo 세팅 대기 (API 요청 전)
    // await this.ensureShopNoReady();

    let mallId = store.state.mallId;
    let appCode = store.state.appCode;
    let mallType = store.state.mallType;
    let shopNo = store.state.shopNo;
    if (args.length > 0 && args[0]["shop_no"]) {
      shopNo = args[0]["shop_no"];
    }

    // mallType이 설정되지 않은 경우 기본값 설정 또는 대기
    if (mallType === null || mallType === undefined) {
      // 세션 스토리지에서 mallType 확인
      const sessionMallType = sessionStorage.getItem(`shoplus_cert_mallType`);
      if (sessionMallType) {
        mallType = sessionMallType;
        store.commit("SET_MALL_TYPE", sessionMallType);
      } else {
        // 기본값 설정
        mallType = "mall";
        store.commit("SET_MALL_TYPE", "mall");
      }
    }

    if ((!mallId || !appCode) && mallType == null) {
      return null;
    }

    args.unshift(shopNo);
    args.unshift(mallId);
    args.unshift(mallType === "imweb" ? "imweb" : "mall");
    args.unshift(appCode);

    let uri = match.path;
    // {index} 가 있는데 args가 없으면 false 처리
    for (let index = 0; index < args.length; index++) {
      let search = `{${index}}`;
      if (uri.includes(search) && !args[index]) {
        return null;
      }
      uri = uri.replace(search, args[index]);
    }

    // 남아있는 {index} 패턴이 있는지 확인 (args가 부족한 경우)
    if (uri.match(/\{\d+\}/)) {
      return null;
    }

    // console.log("APIEntry", uri, match.method);

    return new APIEntry(uri, match.method);
  },
  /**
   * api request
   * @param {APIEntry} entry API URI 맵핑 객체
   * @param {Object} payload 요청 본문 파라미터
   */
  api: async function(entry, payload) {
    if (entry === null) {
      throw new Error("'entry' parameter is required.");
    }
    // status code 확인 하여 토큰 갱신 처리
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.interceptors.response.use(null, async (error) => {
      // LOGIN 액션 실행 ( CAFE24 )
      // login_check API인 경우 401 에러 처리하지 않음
      const isLoginCheckAPI = error.config && error.config.url && error.config.url.includes("login_check");

      console.log("interceptors check", store.state, error.response.status);
      if (error.config && error.response && error.response.status === 401 && !isLoginCheckAPI) {
        if (store.state.mallType === "imweb") {
          // imweb의 경우 토큰 갱신 관리자 사용하여 중복 refresh 방지
          try {
            const newToken = await tokenRefreshManager.safeRefreshToken();
            error.config.headers.Authorization = "Bearer " + newToken;
            return axios.request(error.config);
          } catch (refreshError) {
            console.error("Token refresh failed in interceptor:", refreshError);
            alert("로그인이 만료되었습니다.\n다시 로그인해주세요.");
            // location.href = `/authservice/login`;
            // return Promise.reject(refreshError);
          }
        } else {
          // cafe24의 경우 무한루프 방지 로직 추가
          try {
            await store.dispatch("REFRESH_ACCESS_TOKEN", store);
            error.config.headers.Authorization = store.state.accessToken;
            return axios.request(error.config);
          } catch (refreshError) {
            console.error("Token refresh failed in interceptor:", refreshError);
            // 토큰 갱신 실패 시 로그인 페이지로 리다이렉트
            alert("인증이 만료되었습니다.\n다시 로그인해주세요.");
            if (store.state.mallId) {
              location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
            }
            return Promise.reject(refreshError);
          }
        }
      } else if (
        error.config &&
        error.response &&
        error.response.status === 404 &&
        error.response.data.message &&
        error.response.data.message == "Not found mall_id"
      ) {
        if (store.state.mallType === "imweb") {
          alert("인증키 값이 만료되었습니다.\n다시 로그인해주세요.");
          // location.href = "https://imweb.me/login";
          location.href = `/authservice/login`;
        } else if (store.state.mallType === "cafe24") {
          alert("카페24 인증키 값이 만료되었습니다.\n앱스토어 목록에서 다시 접속해주세요.");
          location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
        }
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      } else if (
        error.config &&
        error.response &&
        error.response.status === 403 &&
        error.response.data.message &&
        error.response.data.message == "RefreshToken expired"
      ) {
        if (store.state.mallType === "imweb") {
          alert("인증키 값이 만료되었습니다.\n다시 로그인해주세요.");
          // location.href = "https://imweb.me/login";
          location.href = `/authservice/login`;
        } else if (store.state.mallType === "cafe24") {
          alert("카페24 인증키 값이 만료되었습니다.\n앱스토어 목록에서 다시 접속해주세요.");
          location.href = `https://${store.state.mallId}.cafe24.com/disp/admin/shop1/myapps/list`;
        }
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      }

      // LOGIN 액션 실행 ( SHOPLUS )
      if (store.state.mallType == "shoplus" && error.config) {
        if (error.response.status === 401) {
          await store.dispatch("SET_SHOPLUE_ACCESS_REFRESH_TOKEN", store.state.refreshToken);
          error.config.headers.Authorization = store.state.accessToken;
          return axios.request(error.config);
        }
        if (error.response.status === 404) {
          sessionStorage.clear();
          localStorage.clear();
          location.href = "/shoplus_service";
        }
      }

      return Promise.reject(error);
    });

    let baseURL = "";
    if (!store.state.mallType || ["imweb", "mall"].includes(store.state.mallType)) {
      baseURL = CONFIG.CAFE24_API_HOST;
    } else {
      baseURL = CONFIG.API_HOST;
    }
    let statement = {
      baseURL: baseURL,
      url: entry.getPath(),
      method: entry.getMethod(),
    };

    if (payload) {
      if (["POST", "DELETE", "PUT"].includes(entry.getMethod())) {
        statement.data = payload;
      } else {
        statement.params = payload;
      }
    }

    let res = await axios(statement);

    return res.data;
  },

  // shopNo 세팅 대기 함수
  ensureShopNoReady: async function(maxRetry = 20, interval = 100) {
    let retry = 0;
    while (!store.state.shopNo && retry < maxRetry) {
      await new Promise((res) => setTimeout(res, interval));
      retry++;
    }
    if (!store.state.shopNo) {
      alert("상점 정보가 초기화되지 않았습니다. 새로고침 해주세요.");
      throw new Error("shopNo가 설정되지 않았습니다.");
    }
  },
  /**
   * date 포멧
   * @param {new Date} date
   */
  yyyymmdd: function(date) {
    let yyyy = date.getFullYear().toString();
    let mm = (date.getMonth() + 1).toString();
    let dd = date.getDate().toString();
    return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]);
  },
  /**
   * 숫자만 입력 체크
   */
  checkNumber: function(e) {
    if (e.keyCode == 69 || e.keyCode == 190 || e.keyCode == 109 || e.keyCode == 189) {
      e.preventDefault();
      return false;
    }
  },
  replaceNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1);
    e.target.value = chkNumber === true ? Number(replaceVal) : replaceVal;
    if (chkNumber === true && e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  replaceMaxNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1);
    e.target.value = chkNumber === true ? Number(replaceVal) : replaceVal;
    if (chkNumber === true && e.target.value == 0) {
      e.target.value = "";
    }
    if (replaceVal > 10000) {
      e.target.value = 10000;
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },

  replaceDateCount: function(e, type) {
    let val = e.target.value;
    let max = type === "y" || type === "m" ? 2 : 3;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max);
    e.target.value = Number(replaceVal);
    if (e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  urlPath: function() {
    let pathArray = window.location.pathname.split("/");
    return pathArray[1];
  },
  getUrlParameter: function(name) {
    let regExp = new RegExp("[?&]" + name + "=([^&#]*)", "i");
    let result = window.location.search.match(regExp);
    if (result) {
      return decodeURIComponent(result[1]);
    }
    return null;
  },
  isPhoneNumber: function(phone_number) {
    let regExp = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
    let result = regExp.test(phone_number);
    return result;
  },
  isMail: function(mail) {
    let regExp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
    let result = regExp.test(mail);
    return result;
  },
  isCustomCheck: function() {
    const mallId = store.state.mallId;
    const shopNo = store.state.shopNo;
    if (mallId === "coggiri001") {
      if (shopNo === "1") {
        return "freshband_kr";
      } else if (shopNo === "5") {
        return "freshband_jp";
      }
    } else if (mallId === "freshband") {
      if (shopNo === "3") {
        return "freshband_kr";
      } else if (shopNo === "17") {
        return "freshband_jp";
      }
    } else if (mallId === "rusica1") {
      if (shopNo === "1") {
        return "rusica1_custom";
      }
    } else if (mallId === "surping1") {
      if (shopNo === "1") {
        return "as_custom"; // A/S 메뉴 노출 설정
      }
    } else if (mallId === "microkorea") {
      if (shopNo === "1") {
        return "as_custom"; // A/S 메뉴 노출 설정
      }
    }
    return false;
  },
});
